export * from "@bytel/logger-core";
import { axiosInterceptorFactory, wrapAxiosInstanceWithLogger } from "@bytel/logger-core";
import { getCookies } from "./helpers/index.js";
import { loggerLinkFactory } from "./graphql/apollo.js";
import { WebPrismeLogger } from "./WebPrismeLogger.js";
export {
  WebPrismeLogger,
  axiosInterceptorFactory,
  getCookies,
  loggerLinkFactory,
  wrapAxiosInstanceWithLogger
};
//# sourceMappingURL=index.js.map
